import React from 'react';

import { EventCatcherScope } from '@repo/event-processor';
import { Button, transparentTheme } from '@repo/ui/components/Buttons';
import { themeStyle } from '@repo/ui/theming';

import {
  CardDivider,
  HeaderWrapper,
  VerticalDivider,
} from 'components/AiTools/RigthPanel/styles';
import { HeaderProps } from 'components/AiTools/RigthPanel/types';

const buttonTheme = {
  ...transparentTheme,
  color: themeStyle.varInkMedium,
  backgroundActiveColor: themeStyle.transparent,
  padding: '0',
  height: '30px',
  activeFillColor: themeStyle.transparent,
};

const Header = <Tab extends string>({
  tabs,
  activeTab,
  onTabClick,
}: HeaderProps<Tab>): React.ReactElement => {
  return (
    <EventCatcherScope module="aiToolsRightPanelHeader">
      <HeaderWrapper>
        {tabs.map((tab, index) => {
          if (index === 0) {
            return (
              <Button
                key={tab.id}
                icon={{ component: tab.icon, height: '16px' }}
                isActive={tabs.length <= 1 || activeTab === tab.id}
                isCentered={false}
                label={tab.label}
                name="headerTabButton"
                theme={{
                  ...buttonTheme,
                  iconActiveColor: themeStyle.varInkMain,
                }}
                width={tab.width}
                onClick={(): void => onTabClick?.(tab.id)}
              />
            );
          }

          return (
            <React.Fragment key={tab.id}>
              <VerticalDivider />
              <Button
                icon={{ component: tab.icon, height: '16px' }}
                isActive={activeTab === tab.id}
                label={tab.label}
                name="headerTabButton"
                theme={{
                  ...buttonTheme,
                  iconActiveColor: 'transparent',
                  iconSecondaryActiveColor: themeStyle.varInkMain,
                }}
                width={tab.width}
                onClick={(): void => onTabClick?.(tab.id)}
              />
            </React.Fragment>
          );
        })}
      </HeaderWrapper>
      <CardDivider />
    </EventCatcherScope>
  );
};

export default Header;
